<template lang="pug">
    v-layout(class="m-block-auth-attention" fill-height)
        v-flex(justify-center align-self-center)
            v-layout(justify-center)
                e-typography-heading-1 {{ $t(`modules.blocks.${name}.title`) }}
            v-layout(justify-center)
                e-typography-body(tag="div" class="text--secondary darken3") {{ description }}
            v-layout(justify-center)
                e-typography-links(@click="logoutAction" class="m-block-auth-attention__logout-link") {{ $t(`modules.blocks.${name}.link`) }}
</template>

<script>
  import {mapActions} from 'vuex';

  let name = 'm-block-auth-attention';
    export default {
        name: name,
        props: {
            name: {
                type: String,
                default: name
            }
        },
        computed: {
            description() {
                return this.$t(`modules.blocks.${name}.description`, {
                    fullUserName: this.fullUserName
                });
            }
        },
        methods: {
            ...mapActions({
                'logout': 'auth/logout'
            }),

            logoutAction() {
                if (this.$auth.watch.authenticated) {
                    this.logout();
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
  .m-block-auth-attention {
    &__logout-link {
      cursor:pointer;
    }
  }
</style>